let active;

export const getPage = () => active;
export const setPage = page => (active = page);
